import React, { useEffect, useState } from 'react'
import Headar from '../Component/Headar'
import Footer from '../Component/Footer'
import MobileHader from '../Component/MobileHader'
import ShapeImg from "../aseets/img/curve.png"
import FounderSection from '../Component/FounderSection'
import { InfinitySpin } from 'react-loader-spinner'
import AboutBaner from "../aseets/img/I2.png"
import AboutSection from '../Component/AboutSection'
import BradCrum from '../Component/BradCrum'
import PlatinumFamily from '../Component/PlatinumFamily'
import axios from 'axios'

const AboutUs = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [bannerImages, setBannerImages] = useState({});
  useEffect(() => {
    const fetchBannerImages = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/list/inner-banners`);
        if (response.data && Array.isArray(response.data) && response.data.length > 4) {
          setBannerImages(response.data,"===>"); 
          
        }
      } catch (error) {
        console.error('Error fetching banner images:', error);
      }
    };

    fetchBannerImages();

    
  }, []);
  useEffect(() => {
    // Simulate a delay of 2 seconds (adjust as needed)
    const delay = 1000;
    setTimeout(() => {
      setIsLoading(false);
    }, delay);
  }, []);
  return (
    <React.Fragment>
          {isLoading ? (
        // Loader component while loading
        <div className="loader-container">
          <InfinitySpin
            color="#000"
            height={50}
            width="200"
            timeout={0} // 0 means no timeout, loader will be displayed until setIsLoading(false) is called
          />
        </div>
      ) : (
      <div>
        <Headar />
        <MobileHader  />
        {/* <BannerSection /> */}
        <BradCrum Title={bannerImages[4]?.Title} BradCrumImg={`${process.env.REACT_APP_API_URL}/${bannerImages[4]?.bannerImage}`} ShapeImg={ShapeImg} color="#fff" />
        <AboutSection />
        <FounderSection />
        <PlatinumFamily />
        <Footer />
        </div>
         )}
    </React.Fragment>
  )
}

export default AboutUs